<template>
    <div v-for="(product, index) in props.products" :key="index"
        class="w-full  h-1/3 flex justify-start items-center border-b border-gray-200  ">

        <!-- Image Container with Square Aspect Ratio -->
        <div class="w-2/5 flex flex-col justify-center">
            <div class="relative w-3/4 pb-[75%] rounded-lg overflow-hidden">
                <img class="absolute top-0 left-0 w-full h-full object-cover lg:object-cover" :src="product.image"
                    alt="Product Image" />
            </div>
        </div>
        <div class="w-3/4 h-full px-4 pt-2  lg:p-4  flex flex-col  ">
            <div class="text-sm  text-gray-600 lg:text-lg"> {{ product.name }}</div>
            <div class="w-full  flex justify-between  items-center lg:block mt-2 lg:mt-0">

                <div class=" text-xs lg:text-sm font-bold text-gray-700">{{ $t("quantity") }} {{ product.quantity }}
                </div>
                <div class=" text-xs lg:text-sm font-bold text-gray-700">{{ $t("price") }} {{ product.price }} </div>
            </div>


        </div>


    </div>
</template>



<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    products: Array
})

</script>